import * as React from 'react';

import { colorsV2 } from '../../colors-v2';
import { Typography } from '../../DesignSystemV2/Typography';
import { TitleProps } from 'antd/lib/typography/Title';
import styled from 'styled-components';

const Main = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr) max-content;
  align-items: center;
  cursor: pointer;
  &&&& {
    h1,
    h2,
    h3 {
      font-weight: 400;
    }
  }
`;

export interface FilterItemProps
  extends React.HTMLAttributes<HTMLDivElement>,
    Partial<Pick<TitleProps, 'level'>> {
  checked?: boolean;
}

export const FilterItem = (props: FilterItemProps) => {
  const { children, checked = false, style, level, ...rest } = props;

  return (
    <Main style={style} {...rest}>
      <div>
        {level ? (
          <Typography.Title variant="regular/16" level={level} color="black100">
            {children}
          </Typography.Title>
        ) : (
          <Typography.Text variant="regular/16" color="black100">
            {children}
          </Typography.Text>
        )}
      </div>
      <div>{checked ? <IconChecked /> : <IconUncheck />}</div>
    </Main>
  );
};

const IconChecked = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="4" y="4" width="16" height="16" rx="4" fill={colorsV2.primary100} />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.70711 11.2929C9.31658 10.9024 8.68342 10.9024 8.29289 11.2929C7.90237 11.6834 7.90237 12.3166 8.29289 12.7071L10.2929 14.7071C10.6834 15.0976 11.3166 15.0976 11.7071 14.7071L15.7071 10.7071C16.0976 10.3166 16.0976 9.68342 15.7071 9.29289C15.3166 8.90237 14.6834 8.90237 14.2929 9.29289L11 12.5858L9.70711 11.2929Z"
        fill="white"
      />
    </svg>
  );
};

const IconUncheck = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect
        x="5"
        y="5"
        width="14"
        height="14"
        rx="3"
        fill={colorsV2.gray5}
        stroke={colorsV2.gray40}
        strokeWidth="2"
      />
    </svg>
  );
};
